import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StaticFileService } from '../../static-file.service';
import { RestApiService } from '../../rest-api.service';
import { CookieService } from '../../cookie.service';
import { GoogleAnalyticsService } from '../../google-analytics.service';

@Component({
  selector: 'app-item-modal',
  templateUrl: './item-modal.component.html',
  styleUrls: ['./item-modal.component.css']
})
export class ItemModalComponent implements OnInit {
  public skuId: any;
  public itemInfo: any = null;
  public isInCart: boolean;
  public fullView: boolean = false;

  constructor(private router: Router,
              private route: ActivatedRoute,
              public staticFileService: StaticFileService,
              private restApi: RestApiService,
              private cookieService: CookieService,
              private gs: GoogleAnalyticsService,
              private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'noscroll');
    this.skuId = this.route.snapshot.paramMap.get('id');
    const type = this.route.snapshot.url[0].path;
    this.isInCart = this.cookieService.isInCart(this.skuId);
    this.init(type);
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'noscroll');
  }

  private async init(type: string) {
    switch (type) {
      case 'original':
        this.itemInfo = await this.restApi.getOriginal(this.skuId);
        break;

      case 'print':
        this.itemInfo = await this.restApi.getPrint(this.skuId);
        break;

      case 'past':
        this.itemInfo = await this.restApi.getPastWork(this.skuId);
        break;

      default:
        break;
    }
  }

  public close() {
    this.router.navigate([{outlets: {view_art: null}}]);
  }

  public addToCart() {
    this.isInCart = true;
    this.cookieService.addToCart(this.itemInfo.id);
    this.gs.event('add_to_cart', 'ecommerce', 'click', this.itemInfo.title);
    this.close();
  }

  public showFullView() {
    this.fullView = true;
    this.gs.event('full_view', 'engagement', 'click', this.itemInfo.title);
  }

  public hideFullView() {
    this.fullView = false;
  }

}
